import { useMutation } from "@/compat/reactQuery";
import queryKeys from "../../../constants/queryKeys";
import reactQueryUtils from "../../../utils/reactQueryUtils";
import actionService from "../../services/actionService";

const { client } = reactQueryUtils;

// Refresh the action lists + RA view (Action Plan, metrics, History counts) on save.
const useSaveAction = () =>
    useMutation(actionService.update, {
        onSuccess: () => {
            client.invalidateQueries({ queryKey: [queryKeys.currentActions] });
            client.invalidateQueries({ queryKey: [queryKeys.riskAssessmentHistory] });
            client.invalidateQueries({ queryKey: [queryKeys.riskAssessment] });
        },
    });

export default useSaveAction;
